<template>
	<div class="board-wrapper main-container-background-color">
		<aside class="right-side" :class="{ 'fold': isFold }">
			<header-bar :is-fold="isFold" :custom-title="title" />
			<section class="body-wrapper">
				<div class="scroll-layer">
					<slot></slot>
				</div>
			</section>
		</aside>
	</div>
</template>

<script>
import HeaderBar from "./header/HeaderBar";

function b64DecodeUnicode(str) {
	return decodeURIComponent(
		Array.prototype.map
			.call(atob(str), c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
			.join("")
	);
}

function parseJwt(token) {
	const base64Url = token.split(".")[1];
	const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	return JSON.parse(b64DecodeUnicode(base64));
}

export default {
	name: "PageTemplate",
	components: {
		HeaderBar
	},
	props: {
		title: {
			type: String,
			default: null
		}
	},
	computed: {
		isFold() {
			return this.$store.getters.isFold;
		},

		user() {
			return this.$store.getters.user;
		}
	},
	methods: {
		initTokenCheck() {
			const tokenName = "winepointUserToken";
			const token = document.cookie.match(`(^|;) ?${tokenName}=([^;]*)(;|$)`);

			if (!token) {
				this.$toast("세션이 만료되어 로그아웃됩니다.");

				this.clearIntervalTokenCheck();

				this.$store.dispatch("logout");
				this.$router.replace("/").catch(error => {
					if (error.name != "NavigationDuplicated") {
						throw error;
					}
				});
				this.$store.commit("setFoldState", true);

				return;
			}

			const decryptToken = parseJwt(token[2]);

			this.tempUserEmail = decryptToken.email;
			this.$store.commit("initUser", decryptToken);

			if (window.innerWidth <= 1024) this.$store.commit("setFoldState", true);
			else this.$store.commit("setFoldState", false);
		},

		intervalTokenCheck() {
			const tokenName = "winepointUserToken";
			const token = document.cookie.match(`(^|;) ?${tokenName}=([^;]*)(;|$)`);

			if (!token) {
				this.$toast("세션이 만료되어 로그아웃됩니다.");

				this.clearIntervalTokenCheck();

				this.$store.dispatch("logout");
				this.$modal.changeToComponent(this.$modal.modalType.RetryLogin, {
					email: this.tempUserEmail,
					intervalTokenCheck: this.setIntervalTokenCheck
				});

				return;
			}

			const decryptToken = parseJwt(token[2]);

			this.tempUserEmail = decryptToken.email;
			this.$store.commit("initUser", decryptToken);
		},

		setIntervalTokenCheck() {
			this.intervalInstance = setInterval(this.intervalTokenCheck, 1000 * 10);
		},

		clearIntervalTokenCheck() {
			clearInterval(this.intervalInstance);
		}
	},
	data() {
		return {
			intervalInstance: null,
			tempUserEmail: null
		};
	},
	mounted() {
		this.initTokenCheck();

		this.setIntervalTokenCheck();
	},
	destroyed() {
		this.clearIntervalTokenCheck();
	}
};
</script>

<style lang="scss" scoped>
.board-wrapper {
	.right-side {
		margin-left: 220px;
		transition: margin-left 0.2s ease-in-out 0s;

		.body-wrapper {
			padding: 20px 30px 20px;
		}
	}

	.fold {
		margin-left: 0;
	}
}

@media screen and (max-width: 1024px) {
	.board-wrapper {
		width: 100%;
		height: 100vh;

		.right-side {
			margin-left: 0;
			width: 100%;
			height: 100%;

			.body-wrapper {
				padding: 68px 10px 12px 10px;
				margin: 0;

				width: 100%;
				height: 100%;

				display: flex;
				flex-direction: column;
				justify-content: center;

				.scroll-layer {
					width: 100%;
					height: 100%;

					overflow-y: scroll;
					-webkit-overflow-scrolling: touch;

					padding-bottom: 120px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/page-template/PageTemplate.vue